module.exports = "<div class=\"single\">\n  <router-outlet></router-outlet>\n</div>\n"